export default __webpack_public_path__ + "static/media/Search.de9630a2.svg";